<template>
  <div class="IriadeApplicationMediaBlock mb-5">
    <div @click="downloadFile"
         v-if="block.config.media.type === 'MediaFile'"
         class="py-2"
         style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <div class="PrevisualisationMediaCard">
        <img :src="thumbnailUrl"
             style="max-width: 100%">
        <h3 v-if="this.block.config.media.title">{{this.block.config.media.title}}</h3>
        <p v-if="this.block.config.media.description">{{this.block.config.media.description}}</p>
      </div>
    </div>

    <IriadeVimeoPlayer v-if="block.config.media.type === 'MediaVimeo'"
                       :video-url="block.config.media.media_url"></IriadeVimeoPlayer>

    <YoutubePlayer v-if="block.config.media.type === 'MediaYoutube'"
                       :video-url="block.config.media.media_url"></YoutubePlayer>

    <IriadeSoundcloudPlayer v-if="block.config.media.type === 'MediaSoundcloud'"
                            :videoUrl="block.config.media.media_url"></IriadeSoundcloudPlayer>

    <IriadeLink v-if="block.config.media.type === 'MediaLink'"
                :linkUrl="block.config.media.media_url"
                :linkLabel="block.config.media.title"></IriadeLink>
    <!--<IriadeFile v-if="block.config.media.type === 'MediaFile'"
                :file_title="block.config.media.title"
                :media_url="block.config.media.media_url"></IriadeFile>-->
  </div>
</template>

<script>
  import api from '../../../../api'
  import FileSaver from 'file-saver'
  import IriadeBlockMixin from '../IriadeBlockMixin'
  import IriadeSoundcloudPlayer from 'components/Iriade/IriadeSoundcloudPlayer'
  import IriadeFile from 'components/Iriade/IriadeFile'
  import IriadeLink from 'components/Iriade/IriadeLink'
  import IriadeVimeoPlayer from 'components/Iriade/IriadeVimeoPlayer'
  import YoutubePlayer from "../../../YoutubePlayer";

  export default {
    components: {
      IriadeVimeoPlayer,
      IriadeSoundcloudPlayer,
      IriadeFile,
      IriadeLink,
      YoutubePlayer,
    },

    computed: {
      thumbnailUrl () {
        return `${process.env.VUE_APP_API_URL}/api/applicationMedias/${this.block.config.media.id}/thumbnail`
      }
    },

    methods: {
      downloadFile () {
        api.get(`applicationMedias/${this.block.config.media.id}/file`, {responseType: 'blob'})
          .then(result => {
            FileSaver.saveAs(result.data)
          })
      }
    },

    mixins: [IriadeBlockMixin],
  }
</script>

<style lang="scss"
       type="text/scss">
  .IriadeApplicationMediaBlock {
    .MediaCard {
      flex: 1 0 300px;
      box-sizing: border-box;
      margin: 1rem .5em;
      padding: 10px;
      cursor: pointer;
      user-select: none;
      border-radius: 12px;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);

      @media screen and (min-width: 40em) {
        max-width: calc(50% - 1em);
      }

      @media screen and (min-width: 60em) {
        max-width: calc(25% - 1em);
      }

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>
